import LoginPage from "./LoginPage";
import { useEffect } from "react";

// TODO Remove the logout page from the flow.
// Migrate the local storage clear somewhere else.
export function Logout() {
  useEffect(() => {
    window.localStorage.clear();
  }, []);

  return <LoginPage />;
}
